'use strict';

var ROMServiceTypeFilterFactory = function ROMServiceTypeFilterFactory(DataFilter) {
  function ROMServiceTypeFilter() {
    DataFilter.call(this, ['rom-analysis-loco-mode', 'rom-analysis-demand-pax-mode', 'rom-analysis-flattened-services-mode'], 'filter-component', 1);
  }
  ROMServiceTypeFilter.prototype = Object.create(DataFilter.prototype);
  ROMServiceTypeFilter.prototype.filter = function (data, range) {
    range = range[0];
    if (range.length === 2) {
      return data;
    }
    var filtered = DataFilter.prototype.filter(data, range.isCodeShare, 'isCodeShare');
    return filtered;
  };
  return ROMServiceTypeFilter;
};
ROMServiceTypeFilterFactory.$inject = ['DataFilterFactory'];
module.exports = ROMServiceTypeFilterFactory;